import {
  Component,
  Inject,
  Input,
  OnInit
} from '@angular/core';
import { ChartsService } from '../../charts.service';
import { ThemeColor } from 'app/common/enums/theme-color.enum';
import { ZingChartComponent } from '../base-classes/zing-chart';
import { ColorThemeService } from 'app/common/services/color-theme.service';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-delta-chart',
  templateUrl: './delta-chart.component.html',
  styleUrls: ['./delta-chart.component.scss']
})

export class DeltaChartComponent extends ZingChartComponent implements OnInit {

  constructor(
    private chartService: ChartsService,
    protected colorThemeService: ColorThemeService,
    @Inject(AppStore) protected readonly store: Redux.Store<AppState>,
    protected readonly paymentWindowService: PaymentWindowService
  ) {
    super(
      colorThemeService,
      store,
      paymentWindowService
    );
  }

  public firstDeltaActive = true;
  public secondDeltaActive = true;

  private minPercent = 0;
  private maxPercent = 100;
  private step = 0.1;
  private period: any = [];
  private value0: any = [];
  private value1: any = [];

  private _type = 'SKEW'; // SKEW, 'BUTTERFLY'
  public get type() {
    return this._type;
  }

  @Input()
  public set type(value) {
    this._type = value;
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public toggleChart(chart): void {
    this[chart] = !this[chart];
    this.reRenderChart();
  }

  protected getChartData(): void {
    if (this.isChartInitialized) {
      return;
    }
    this.chartService.getDeltaSurfaceData(this.instrument.stockId, this.instrument.regionId, this._type, [0.1, 0.25]).then(data => {
      if (data.series.length > 0) {
        for (let i = 0; i < data.series.length; i++) {
          const rows = data.series[i].rows;
          if (rows.length > 0) {
            if (this.period.length === 0) {
              this.period = rows.map(row => {
                return row.period;
              });
            }
            this['value' + i] = rows.map(row => {
              return row.value;
            });
          }
        }
        const values = [...this.value0, ...this.value1];
        this.maxPercent = Math.ceil(Math.max.apply(Math, values) * 10) / 10;
        this.minPercent = Math.floor(Math.min.apply(Math, values) * 10) / 10;
        if (!this.isChartInitialized) {
          this.renderChart();
          this.isChartInitialized = true;
        }
      }
    });
  }

  protected get getChartConfig(): Object {
    return {
      'type': 'line',
      'background-color': this.theme === ThemeColor.DARK ? '#242525' : '#fff',
      'utc': true,
      'plotarea': {
        'margin': '15px 25px 50px 75px',
        'background-color': this.backgroundColor
      },
      'scale-x': {
        'values': this.period,
        'shadow': 0,
        'line-color': this.lineColor,
        'tick': {
          'line-color': this.lineColor
        },
        'guide': {
          'line-color': this.lineColor
        },
        'item': {
          'font-color': this.lineColor
        },
        'label': {
          'text': 'Period',
          'font-color': this.lineColor,
          'font-weight': 'normal'
        },
        'minor-ticks': 0
      },
      'scale-y': {
        'values': this.minPercent + ':' + this.maxPercent + ':' + this.step,
        'format': '%v %',
        'line-color': this.lineColor,
        'shadow': 0,
        'tick': {
          'line-color': this.lineColor
        },
        'guide': {
          'line-color': this.lineColor,
          'line-style': 'dashed'
        },
        'item': {
          'font-color': this.lineColor
        },
        'label': {
          'text': 'Skew',
          'font-color': this.lineColor,
          'font-weight': 'normal'
        },
        'minor-ticks': 0,
        'thousands-separator': ','
      },
      'crosshair-x': {
        'line-color': this.lineColor,
        'plot-label': {
          'border-radius': '3px',
          'border-width': '1px',
          'border-color': this.lineColor,
          'padding': '10px',
          'font-weight': 'bold'
        },
        'scale-label': {
          'font-color': '#00baf0',
          'background-color': this.backgroundColor,
          'border-radius': '3px'
        }
      },
      'tooltip': {
        'visible': false
      },
      'plot': {
        'tooltip-text': '%t views: %v<br>%k',
        'shadow': 0,
        'line-width': '3px',
        'marker': {
          'type': 'circle',
          'size': 3
        },
        'hover-marker': {
          'type': 'circle',
          'size': 4,
          'border-width': '1px'
        }
      },
      'series': [
        {
          'values': this.value0,
          'visible': this.firstDeltaActive,
          'line-color': '#5F5BFF',
          'text': 'Delta=0.1',
          'marker': {
            'background-color': '#5F5BFF',
            'border-width': 1,
            'shadow': 0,
            'border-color': '#6b68f2'
          }
        },
        {
          'values': this.value1,
          'visible': this.secondDeltaActive,
          'line-color': '#00AD80',
          'text': 'Delta=0.25',
          'marker': {
            'background-color': '#00AD80',
            'border-width': 1,
            'shadow': 0,
            'border-color': '#00e8ac'
          }
        }
      ]
    };
  }
}
